import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject, input, model } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { Observable, of } from 'rxjs';

import { Search } from '../../../models';
import { BaseEditService, ModalService } from '../../../services';
import { FormlyService } from '../../../services/component-services/formly.service';
import { SummaryTopComponent } from '../../summary-top/summary-top.component';
import { BaseInlineFormComponent } from '../../base-inline-form/base-inline-form.component';
import { ignoreModalError } from '../../../helpers';
import { GridComponent } from '../../grids/grid/grid.component';

@Component({
  selector: 'app-search-modal',
  templateUrl: './search-modal.component.html',
  styleUrl: './search-modal.component.scss',
  imports: [SummaryTopComponent, BaseInlineFormComponent, GridComponent, AsyncPipe],
})
export class SearchModalComponent implements OnInit {
  private readonly modalService = inject(ModalService);
  private readonly formlyService = inject(FormlyService);

  public readonly stateKey = input<string>();
  public readonly header = model('');
  public readonly allLabel = model($localize`All`);
  public readonly id = model<string>();
  public readonly id2 = model<string>();
  public readonly bool1 = model<boolean>();
  public readonly bool2 = model<boolean>();
  public readonly columnDefs = model<ColDef[]>([]);
  public readonly createComponent = model<any>();
  public readonly service = model<BaseEditService<any, any>>();
  public readonly results$ = model<Observable<any[]>>(of([]));
  public readonly model = model<Search>({} as Search);
  public readonly showSave = model(true);

  protected fields: FormlyFieldConfig[];

  ngOnInit() {
    this.getFields();
  }

  get gridStateKey() {
    return `SearchModal.${this.stateKey() ?? this.header()}`;
  }

  edit(model: any) {
    this.modalService.close(model);
  }

  private getFields() {
    this.fields = [
      this.formlyService.search(
        'search',
        '',
        this.service(),
        (results: Observable<any[]>) => this.results$.set(results),
        { bool1: this.bool1(), bool2: this.bool2() },
        undefined,
        {
          'props.id': (field: FormlyFieldConfig) => (field.model?.includeAll ? undefined : this.id()),
          'props.id2': (field: FormlyFieldConfig) => (field.model?.includeAll ? undefined : this.id2()),
        },
      ),
    ];

    if (this.id() && this.allLabel()) {
      this.fields.push(this.formlyService.checkbox('includeAll', this.allLabel()));
    }

    if (this.createComponent()) {
      this.fields.push(this.formlyService.createButton(() => this.create()));
    }
  }

  private create() {
    const { modal, component } = this.modalService.openXL<any>(this.createComponent());
    component.id.set(this.id());
    component.id2.set(this.id2());
    modal.result.then((result) => this.modalService.close(result), ignoreModalError);
  }
}
